import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sliceLimit'
})
export class SliceLimitPipe implements PipeTransform {
  limit = 100;

  transform(value: string): string {
    if (value && value.length > this.limit) {
      return `${value.substring(0, this.limit).trim()}...`;
    }
    return value;
  }
}
